import { render, staticRenderFns } from "./NewIntegralPro.vue?vue&type=template&id=6138dd59&scoped=true"
import script from "./NewIntegralPro.vue?vue&type=script&lang=js"
export * from "./NewIntegralPro.vue?vue&type=script&lang=js"
import style0 from "./NewIntegralPro.vue?vue&type=style&index=0&id=6138dd59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6138dd59",
  null
  
)

export default component.exports